import { render, staticRenderFns } from "./Each_Orga.vue?vue&type=template&id=9f9e649c&scoped=true"
import script from "./Each_Orga.vue?vue&type=script&lang=js"
export * from "./Each_Orga.vue?vue&type=script&lang=js"
import style0 from "./Each_Orga.vue?vue&type=style&index=0&id=9f9e649c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9e649c",
  null
  
)

export default component.exports